var map = {
	"./altf/bot-avatar.png": "53de",
	"./datarmony/bot-avatar.png": "3f8e",
	"./default/bot-avatar.png": "814f",
	"./euruni/bot-avatar.png": "8c6d",
	"./foundever/bot-avatar.png": "002a",
	"./gala/bot-avatar.png": "ebeb",
	"./getboarded/bot-avatar.png": "9b4f",
	"./ie/bot-avatar.png": "9296",
	"./sitel-learning-sandbox/bot-avatar.png": "10d0",
	"./sitel-learning/bot-avatar.png": "9b74b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "79cc";